export default "__VITE_ASSET__3736731c__"